(function () {
  "use strict";

  var FILTER_KEY = "filter.v.m.car.ids";
  var REGISTRATION_KEY = "amp_vehicle_registration_v1";
  var STYLE_ID = "amp-vehicle-filter-empty-state-styles";
  var LOOKUP_ENDPOINT = "https://plain-bonus-da6d.automotopartuk.workers.dev/TecdocToCatDLB.jsonEndpoint";
  var scheduled = false;
  var lookupStartedFor = "";
  var lookedUpVehicle = null;
  var vehiclePartCountRequests = {};

  function activeVehicleId() {
    var params = new URLSearchParams(window.location.search);
    var values = params.getAll(FILTER_KEY).reduce(function (items, value) {
      return items.concat(String(value || "").split(","));
    }, []);
    return values.map(function (value) { return value.trim(); })
      .find(function (value) { return /^\d+$/.test(value); }) || "";
  }

  function titleCase(value) {
    var acronyms = {
      BMW: "BMW",
      MINI: "MINI",
      VW: "VW",
      SEAT: "SEAT",
      MG: "MG",
      MAN: "MAN",
      DAF: "DAF",
      DS: "DS",
    };
    return String(value || "")
      .trim()
      .split(/\s+/)
      .map(function (word) {
        var upper = word.toUpperCase();
        if (acronyms[upper]) return acronyms[upper];
        return word
          .toLowerCase()
          .split("-")
          .map(function (part) {
            return part ? part.charAt(0).toUpperCase() + part.slice(1) : part;
          })
          .join("-");
      })
      .join(" ");
  }

  function stripDateRange(value) {
    return String(value || "")
      .replace(/\s*\(\d{2}\/\d{4}\s*-\s*(?:\d{2}\/\d{4})?\s*\)\s*$/i, "")
      .replace(/\s*\(\d{4}(?:-\d{2})?\s*-\s*(?:\d{4}(?:-\d{2})?)?\s*\)\s*$/i, "")
      .trim();
  }

  function shortModel(value) {
    var model = stripDateRange(value);
    if (!model) return "";

    var groups = Array.from(model.matchAll(/\(([^)]+)\)/g));
    for (var index = groups.length - 1; index >= 0; index -= 1) {
      var candidate = String(groups[index][1] || "")
        .trim()
        .replace(/_+/g, "")
        .replace(/\s*,\s*/g, "/")
        .replace(/\s*\/\s*/g, "/");
      if (
        candidate &&
        candidate.length <= 22 &&
        /[A-Z0-9]/i.test(candidate) &&
        (/\d/.test(candidate) || /^[A-Z]{1,5}(?:\/[A-Z]{1,5})*$/i.test(candidate))
      ) {
        return candidate.toUpperCase();
      }
    }

    return model.replace(/\s*\([^)]*\)\s*/g, " ").replace(/\s+/g, " ").trim();
  }

  function selectedVehicle() {
    var targetId = activeVehicleId();
    if (lookedUpVehicle && String(lookedUpVehicle.linkageTargetId || "") === targetId) {
      return {
        make: lookedUpVehicle.mfrName || "",
        model: lookedUpVehicle.vehicleModelSeriesName || "",
      };
    }

    var engineSelect = document.getElementById("select-engine");
    var selectedEngine = null;

    if (engineSelect && engineSelect.value) {
      try {
        selectedEngine = JSON.parse(engineSelect.value);
      } catch (error) {
        selectedEngine = null;
      }
    }

    if (
      selectedEngine &&
      String(selectedEngine.linkageTargetId || "") === targetId
    ) {
      return {
        make: selectedEngine.mfrName || "",
        model: selectedEngine.vehicleModelSeriesName || selectedEngine.bodyStyle || "",
      };
    }

    var makeSelect = document.getElementById("select-make");
    var modelSelect = document.getElementById("select-model");
    var makeText = makeSelect && makeSelect.value
      ? String(makeSelect.selectedOptions[0] && makeSelect.selectedOptions[0].textContent || "").trim()
      : "";
    var modelText = modelSelect && modelSelect.value
      ? String(modelSelect.selectedOptions[0] && modelSelect.selectedOptions[0].textContent || "").trim()
      : "";
    if (makeText && modelText) return { make: makeText, model: modelText };

    var visibleVehicle = document.getElementById("vehicle-name");
    var parts = String(visibleVehicle && visibleVehicle.textContent || "")
      .split("/")
      .map(function (part) { return part.trim(); })
      .filter(Boolean);
    return { make: parts[0] || "", model: parts[1] || "" };
  }

  function vehicleLabel() {
    var vehicle = selectedVehicle();
    var make = titleCase(vehicle.make);
    var model = shortModel(vehicle.model);
    if (make && model) return make + " " + model;
    return make || model || "selected vehicle";
  }

  function normaliseManufacturerHandle(value) {
    var handle = String(value || "")
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
    var aliases = {
      "volkswagen": "vw",
      "volkswagen-vw": "vw",
      "vw-volkswagen": "vw",
      "volkswagen-cars": "vw",
      "mercedes": "mercedes-benz",
      "mercedes-benz-ag": "mercedes-benz",
      "mercedes-benz-cars": "mercedes-benz",
      "landrover": "land-rover",
      "land-rover-uk": "land-rover",
      "ds-automobiles": "ds",
      "great-wall-motors": "great-wall",
      "mg-motor": "mg",
      "mini-bmw": "mini",
      "rolls-royce-motor-cars": "rolls-royce",
      "skoda-auto": "skoda",
      "ssang-yong": "ssangyong",
    };
    return aliases[handle] || handle;
  }

  function selectedVehicleCookieForFilter(targetId) {
    try {
      var prefix = "selectedVehicle=";
      var cookie = String(document.cookie || "")
        .split(";")
        .map(function (part) { return part.trim(); })
        .find(function (part) { return part.indexOf(prefix) === 0; });
      if (!cookie) return null;
      var vehicle = JSON.parse(decodeURIComponent(cookie.slice(prefix.length)));
      if (!vehicle || typeof vehicle !== "object") return null;
      var storedTarget = String(vehicle.engineId || vehicle.linkageTargetId || "").trim();
      return storedTarget === targetId ? vehicle : null;
    } catch (error) {
      return null;
    }
  }

  function vehicleCollectionDetails() {
    var targetId = activeVehicleId();
    if (!targetId) return null;

    var cookieVehicle = selectedVehicleCookieForFilter(targetId);
    var storedVehicle = savedVehicleForFilter(targetId);
    var visibleVehicle = selectedVehicle();
    var manufacturerId = String(cookieVehicle && cookieVehicle.manufacturerId || "").trim().toLowerCase();
    if (/^vl_[a-z0-9-]+$/.test(manufacturerId)) {
      manufacturerId = "vl_" + normaliseManufacturerHandle(manufacturerId.slice(3));
    } else {
      var make =
        String(cookieVehicle && cookieVehicle.manufacturer || "").trim() ||
        String(storedVehicle && (storedVehicle.mark || storedVehicle.mfrName || storedVehicle.manufacturer) || "").trim() ||
        String(visibleVehicle.make || "").trim();
      var makeHandle = normaliseManufacturerHandle(make);
      manufacturerId = makeHandle ? "vl_" + makeHandle : "";
    }
    if (!/^vl_[a-z0-9-]+$/.test(manufacturerId)) return null;

    var params = new URLSearchParams();
    params.set(FILTER_KEY, targetId);
    return {
      targetId: targetId,
      manufacturerId: manufacturerId,
      destination: "/collections/" + manufacturerId + "?" + params.toString(),
    };
  }

  function fetchText(url) {
    return window.fetch(url, {
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    }).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status);
      return response.text();
    });
  }

  function fetchJson(url) {
    return fetchText(url).then(function (text) {
      return JSON.parse(String(text || "").trim());
    });
  }

  function cachedVehiclePartCount(cacheKey) {
    try {
      var value = window.sessionStorage.getItem("amp_vehicle_part_count_v1:" + cacheKey);
      if (value === null) return null;
      var count = Number(value);
      return Number.isFinite(count) && count >= 0 ? count : null;
    } catch (error) {
      return null;
    }
  }

  function cacheVehiclePartCount(cacheKey, count) {
    try {
      window.sessionStorage.setItem("amp_vehicle_part_count_v1:" + cacheKey, String(count));
    } catch (error) {}
  }

  function vehiclePartCount(details) {
    var cacheKey = details.targetId + ":" + details.manufacturerId;
    var cachedCount = cachedVehiclePartCount(cacheKey);
    if (cachedCount !== null) return Promise.resolve(cachedCount);
    if (vehiclePartCountRequests[cacheKey]) return vehiclePartCountRequests[cacheKey];

    var collectionParams = new URLSearchParams();
    collectionParams.set(FILTER_KEY, details.targetId);
    collectionParams.set("view", "vehicle-count");
    var collectionUrl = "/collections/" + details.manufacturerId + "?" + collectionParams.toString();

    vehiclePartCountRequests[cacheKey] = fetchJson(collectionUrl)
      .then(function (collectionData) {
        if (!collectionData || collectionData.exists !== true) return 0;
        if (!collectionData.proxyEnabled) {
          return Math.max(0, Number(collectionData.filteredCount) || 0);
        }

        var searchQuery = String(collectionData.proxyQuery || "").trim();
        var lockedVendor = String(collectionData.lockedVendor || "").trim();
        if (!searchQuery || (searchQuery === "*" && !lockedVendor)) return 0;
        if (searchQuery === "*" && lockedVendor) {
          searchQuery = 'vendor:"' + lockedVendor.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
        }

        var searchParams = new URLSearchParams();
        searchParams.set("q", searchQuery);
        if (lockedVendor) searchParams.set("filter.p.vendor", lockedVendor);
        searchParams.set("type", "product");
        searchParams.set("options[prefix]", "last");
        searchParams.set(FILTER_KEY, details.targetId);
        searchParams.set("view", "vehicle-total");
        var defaultSort = String(collectionData.defaultSort || "").trim();
        if (defaultSort) searchParams.set("sort_by", defaultSort);
        return fetchText("/search?" + searchParams.toString()).then(function (html) {
          var documentFragment = new DOMParser().parseFromString(html, "text/html");
          var countMarker = documentFragment.querySelector("[data-amp-vehicle-total]");
          return Math.max(0, Number(countMarker && countMarker.getAttribute("data-amp-vehicle-total")) || 0);
        });
      })
      .then(function (count) {
        cacheVehiclePartCount(cacheKey, count);
        return count;
      })
      .catch(function () {
        return null;
      });
    return vehiclePartCountRequests[cacheKey];
  }

  function browseAllLabel(count) {
    if (count >= 1000) return "Browse 1,000+ parts for this vehicle";
    return "Browse All " + count + (count === 1 ? " part" : " parts") + " for this vehicle";
  }

  function savedVehicleForFilter(targetId) {
    try {
      var vehicle = JSON.parse(window.localStorage.getItem("vehicle") || "null");
      if (!vehicle || typeof vehicle !== "object") return null;
      var storedTarget = String(vehicle.linkageTargetId || vehicle.engineId || "").trim();
      return storedTarget === targetId ? vehicle : null;
    } catch (error) {
      return null;
    }
  }
  function formatRegistration(value) {
    var registration = String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (!registration) return "";
    return registration.length > 3
      ? registration.slice(0, -3) + " " + registration.slice(-3)
      : registration;
  }
  function savedRegistrationForFilter(targetId, storedVehicle) {
    var registration = String(storedVehicle && storedVehicle.registration || "");
    if (registration) return registration;
    if (typeof window.ampVehicleRegistrationForTarget === "function") {
      registration = window.ampVehicleRegistrationForTarget(targetId);
      if (registration) return registration;
    }
    try {
      var saved = JSON.parse(window.localStorage.getItem(REGISTRATION_KEY) || "null");
      if (saved && String(saved.targetId || "") === targetId) {
        return String(saved.registration || "");
      }
    } catch (error) {}
    return "";
  }
  function decorateVehicleFilterChip() {
    if (window.ampVehicleClearInProgress) return;
    var targetId = activeVehicleId();
    if (!targetId) return;
    var storedVehicle = savedVehicleForFilter(targetId);
    var registration = formatRegistration(
      savedRegistrationForFilter(targetId, storedVehicle)
    );
    var label = registration || titleCase(vehicleLabel());
    document.querySelectorAll(".collection-filter-button").forEach(function (chip) {
      var value = chip.querySelector("span:first-child");
      if (!value) return;
      var chipTarget = String(chip.dataset.ampVehicleFilterId || value.textContent || "").trim();
      if (chipTarget !== targetId) return;
      chip.dataset.ampVehicleFilterId = targetId;
      chip.setAttribute("data-amp-remove-vehicle-filter", "true");
      if (value.textContent !== label) value.textContent = label;
      chip.classList.toggle("amp-registration-filter-chip", Boolean(registration));
      chip.setAttribute("aria-label", "Remove vehicle filter " + label);
    });
  }

  function lookupVehicle() {
    var targetId = activeVehicleId();
    if (!targetId || lookupStartedFor === targetId) return;
    lookupStartedFor = targetId;

    window.fetch(LOOKUP_ENDPOINT, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        getLinkageTargets: {
          linkageTargetCountry: "gb",
          lang: "en",
          linkageTargetType: "P",
          linkageTargetIds: [{ id: Number(targetId), type: "P" }],
          perPage: 1,
          page: 1,
        },
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Vehicle lookup failed");
        return response.json();
      })
      .then(function (payload) {
        var vehicle = payload && payload.linkageTargets && payload.linkageTargets[0];
        if (vehicle && String(vehicle.linkageTargetId || "") === targetId) {
          lookedUpVehicle = vehicle;
          scheduleApply();
        }
      })
      .catch(function () {
        /* The selector/visible vehicle remains the safe display fallback. */
      });
  }

  function removeVehicle(destination) {
    var safeDestination =
      typeof destination === "string" || destination instanceof URL
        ? String(destination)
        : window.location.href;
    if (typeof window.ampClearSelectedVehicle === "function") {
      window.ampClearSelectedVehicle({ destination: safeDestination });
      return;
    }
    try {
      window.localStorage.removeItem("vehicle");
      window.localStorage.removeItem("filterId");
      window.localStorage.removeItem(REGISTRATION_KEY);
    } catch (error) {}
    document.cookie = "selectedVehicle=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";

    var url = new URL(safeDestination, window.location.href);
    url.searchParams.delete(FILTER_KEY);
    url.searchParams.delete("page");
    window.location.assign(url.pathname + (url.searchParams.toString() ? "?" + url.searchParams.toString() : ""));
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent =
      ".amp-vehicle-empty-hide-filter-ui .page-layout-sidebar,.amp-vehicle-empty-hide-filter-ui filters-toggle,.amp-vehicle-empty-hide-filter-ui .button-collection-filters-toggle,.amp-vehicle-empty-hide-filter-ui #CollectionActions,.amp-vehicle-empty-hide-filter-ui #ProductCount{display:none!important;}" +
      ".amp-vehicle-empty-hide-filter-ui .facets-wrap.page-layout-with-sidebar{display:block!important;grid-template-areas:'content'!important;grid-template-columns:minmax(0,1fr)!important;}" +
      ".amp-vehicle-empty-hide-filter-ui .page-layout-main-content{grid-column:1/-1;max-width:none!important;min-width:0;width:100%!important;}" +
      ".amp-vehicle-empty-state .amp-vehicle-empty-copy{margin:1rem 0 1.6rem;}" +
      ".amp-vehicle-empty-actions{display:flex;flex-wrap:wrap;gap:.8rem;justify-content:center;}" +
      ".amp-browse-vehicle-button[hidden]{display:none!important;}" +
      ".amp-browse-vehicle-button{appearance:none;background:#fee04d!important;border:1px solid #fee04d!important;border-radius:4px;color:#111!important;display:inline-flex;align-items:center;justify-content:center;font:inherit;font-weight:700;letter-spacing:.02em;line-height:1.2;min-height:46px;padding:.75rem 1.35rem;text-align:center;text-decoration:none;text-transform:uppercase;}" +
      ".amp-browse-vehicle-button:hover,.amp-browse-vehicle-button:focus-visible{background:#f2cf25!important;border-color:#f2cf25!important;color:#111!important;}" +
      ".amp-browse-vehicle-button:focus-visible{outline:3px solid rgba(254,224,77,.45);outline-offset:3px;}" +
      ".amp-remove-vehicle-button{appearance:none;background:#174a8b!important;border:1px solid #174a8b!important;border-radius:4px;color:#fff!important;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font:inherit;font-weight:700;letter-spacing:.02em;line-height:1.2;min-height:46px;padding:.75rem 1.35rem;text-decoration:none;text-transform:uppercase;}" +
      ".amp-remove-vehicle-button:hover,.amp-remove-vehicle-button:focus-visible{background:#0f3568!important;border-color:#0f3568!important;color:#fff!important;}" +
      ".amp-remove-vehicle-button:focus-visible{outline:3px solid rgba(23,74,139,.3);outline-offset:3px;}" +
      "@media(max-width:749px){.amp-vehicle-empty-actions{align-items:stretch;flex-direction:column;margin-inline:auto;max-width:420px;width:calc(100% - 32px);}.amp-browse-vehicle-button,.amp-remove-vehicle-button{width:100%;}}";
    document.head.appendChild(style);
  }

  function markEmptyLayout(container) {
    var root = container.closest('[id^="NativeCollectionGrid-"], [id^="LargeCollectionVehicleGrid-"]');
    if (root) root.classList.add("amp-vehicle-empty-hide-filter-ui");
    document.body.classList.remove("page-layout-sidebar-drawer-open", "overflow-hidden-tablet");
  }

  function addEmptyStateActions(container) {
    var actions = container.querySelector(".amp-vehicle-empty-actions");
    if (!actions) {
      actions = document.createElement("div");
      actions.className = "amp-vehicle-empty-actions";
      container.appendChild(actions);
    }

    var button = container.querySelector(".amp-remove-vehicle-button");
    if (!button) {
      button = document.createElement("button");
      button.type = "button";
      button.className = "amp-remove-vehicle-button";
      button.textContent = "Remove vehicle";
      button.addEventListener("click", function () {
        removeVehicle(window.location.href);
      });
      actions.appendChild(button);
    } else if (button.parentNode !== actions) {
      actions.appendChild(button);
    }

    var details = vehicleCollectionDetails();
    var browseButton = container.querySelector(".amp-browse-vehicle-button");
    var currentVehicleCollection = details && window.location.pathname.replace(/\/$/, "") === "/collections/" + details.manufacturerId;
    if (!details || currentVehicleCollection) {
      if (browseButton) browseButton.remove();
      return;
    }
    if (!browseButton) {
      browseButton = document.createElement("a");
      browseButton.className = "amp-browse-vehicle-button";
      browseButton.hidden = true;
      actions.insertBefore(browseButton, button);
    }
    if (browseButton.getAttribute("href") !== details.destination) {
      browseButton.setAttribute("href", details.destination);
    }
    if (!browseButton.getAttribute("aria-label")) {
      browseButton.setAttribute("aria-label", "Browse all compatible parts for this vehicle");
    }

    vehiclePartCount(details).then(function (count) {
      if (!Number.isFinite(count) || count < 1 || !browseButton.isConnected) {
        if (browseButton.isConnected && !browseButton.hidden) browseButton.hidden = true;
        return;
      }
      var label = browseAllLabel(count);
      if (browseButton.textContent !== label) browseButton.textContent = label;
      if (browseButton.getAttribute("aria-label") !== label) browseButton.setAttribute("aria-label", label);
      if (browseButton.hidden) browseButton.hidden = false;
    });
  }

  function updateNativeEmptyState(container, label) {
    markEmptyLayout(container);
    container.classList.add("amp-vehicle-empty-state");
    var heading = container.querySelector("h1, h2, h3");
    var headingText = "No products found for your " + label;
    if (heading && heading.textContent !== headingText) heading.textContent = headingText;

    var copy = container.querySelector("p");
    if (!copy) {
      copy = document.createElement("p");
      container.appendChild(copy);
    }
    copy.className = "amp-vehicle-empty-copy";
    var copyText = "Your selected vehicle is limiting these results. Remove it to browse this collection without vehicle fitment.";
    if (copy.textContent !== copyText) copy.textContent = copyText;
    addEmptyStateActions(container);
  }

  function updateProxyEmptyState(container, label) {
    markEmptyLayout(container);
    container.classList.add("amp-vehicle-empty-state");
    var heading = container.querySelector(".page-hero-heading");
    var headingText = "No products found for your " + label;
    if (heading && heading.textContent !== headingText) heading.textContent = headingText;

    var copy = container.querySelector(".page-hero-caption");
    if (!copy) {
      copy = document.createElement("p");
      copy.className = "page-hero-caption";
      container.appendChild(copy);
    }
    copy.classList.add("amp-vehicle-empty-copy");
    var copyText = "Your selected vehicle is limiting these results. Remove it to browse this collection without vehicle fitment.";
    if (copy.textContent !== copyText) copy.textContent = copyText;
    addEmptyStateActions(container);
  }

  function applyEmptyState() {
    scheduled = false;
    if (window.ampVehicleClearInProgress) return;
    document.querySelectorAll(".amp-vehicle-empty-hide-filter-ui").forEach(function (root) {
      root.classList.remove("amp-vehicle-empty-hide-filter-ui");
    });
        if (!activeVehicleId()) return;
    decorateVehicleFilterChip();
    var nativeEmptyStates = document.querySelectorAll("#product-grid.collection-empty");
    var proxyEmptyStates = [];
    document.querySelectorAll('[id^="LargeCollectionVehicleGrid-"]').forEach(function (mount) {
      var productList = mount.querySelector("#product-grid, #product-rows");
      if (productList && productList.querySelector("li")) return;
      var emptyState = mount.querySelector(".page-hero-empty, .page-hero");
      if (emptyState && (mount.dataset.proxyReady === "true" || emptyState.classList.contains("page-hero-empty"))) {
        proxyEmptyStates.push(emptyState);
      }
    });
    if (!nativeEmptyStates.length && !proxyEmptyStates.length) return;

    lookupVehicle();
    ensureStyles();
    var label = vehicleLabel();

    nativeEmptyStates.forEach(function (container) {
      updateNativeEmptyState(container, label);
    });
    proxyEmptyStates.forEach(function (container) {
      updateProxyEmptyState(container, label);
    });
  }

  function scheduleApply() {
    if (window.ampVehicleClearInProgress) return;
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyEmptyState);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleApply, { once: true });
  } else {
    scheduleApply();
  }

  document.addEventListener("change", function (event) {
    if (event.target && /^(select-make|select-model|select-engine)$/.test(event.target.id)) scheduleApply();
  });
  document.addEventListener("click", function (event) {
    var control = event.target && event.target.closest
      ? event.target.closest("[data-amp-remove-vehicle-filter]")
      : null;
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (typeof window.ampClearSelectedVehicle === "function") {
      window.ampClearSelectedVehicle({ destination: control.getAttribute("href") || window.location.href });
    } else {
      removeVehicle(control.getAttribute("href") || window.location.href);
    }
  }, true);
  window.addEventListener("pageshow", scheduleApply);
  new MutationObserver(scheduleApply).observe(document.documentElement, { childList: true, subtree: true });
})();
